import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=f8da5e5a&scoped=true&"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js&"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&id=f8da5e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8da5e5a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/vigzero/vig-zero-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8da5e5a')) {
      api.createRecord('f8da5e5a', component.options)
    } else {
      api.reload('f8da5e5a', component.options)
    }
    module.hot.accept("./LoaderOverlay.vue?vue&type=template&id=f8da5e5a&scoped=true&", function () {
      api.rerender('f8da5e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/services/LoaderOverlay/LoaderOverlay.vue"
export default component.exports